export const ENQUEUE = '@REDUCKS/ENQUEUE';
export const DEQUEUE = '@REDUCKS/DEQUEUE';
export const COMMENCED = '@REDUCKS/COMMENCED';
export const CEASED = '@REDUCKS/CEASED';
